import { DescriptionBar, SearchBar } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import ManageUsersTab from './components/ManageUsersTab';
import UserPermissionTab from './components/UserPermissionTab';
import MenuVisibilityTab from './components/MenuVisibilityTab';
import { UserGroupOutlineIcon, BadgeCheckOutlineIcon, EyeOutlineIcon } from 'assets/svgs';
import MenuTabSecond from 'components/MenuTabSecond';

// * 탭 인덱스 정의
const MENU_INDEX = {
  MANAGE_USERS: 0,
  USER_PERMISSION: 1,
  MENU_VISIBILITY: 2
};

const ManageUser = () => {
  const { t } = useTranslation();
  const buttonMenuList = [
    t('manageUser.tabs.manageUsers'),
    t('manageUser.tabs.userPermission'),
    t('manageUser.tabs.menuVisibility')
  ];
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(() => {
    const tab = searchParams.get('tab');
    return tab ? parseInt(tab) : MENU_INDEX.MANAGE_USERS;
  });
  const [searchValue, setSearchValue] = useState<string>('');

  // * 탭 클릭 핸들러
  function onClickTab(index: number) {
    setSelectedMenuIndex(index);
    setSearchParams({ tab: index.toString() });
  }

  return (
    <div className="flex h-full w-full flex-col">
      <DescriptionBar
        className="md:px-6"
        title={t('manageUser.pageTitle')} 
        description={t('manageUser.description')}
      />
      <div className="flex flex-row items-center justify-between p-2">
        <div className="flex flex-row gap-2"></div>
      </div>
      <div className="w-full flex-1 flex flex-col">
        <MenuTabSecond
          menuList={buttonMenuList}
          selectedMenuIndex={selectedMenuIndex}
          onClickTab={onClickTab}
          icons={[
            <UserGroupOutlineIcon key="user-group" className="w-5 h-5" />,
            <BadgeCheckOutlineIcon key="badge-check" className="w-5 h-5" />,
            <EyeOutlineIcon key="eye" className="w-5 h-5" />
          ]}
        />
        {selectedMenuIndex === MENU_INDEX.MANAGE_USERS && (
          <>
            <div className="flex flex-row flex-wrap items-center justify-between gap-4 p-6">
              <div className="ml-12">
                <SearchBar
                  className="w-full md:w-60"
                  value={searchValue}
                  setValue={setSearchValue}
                  placeholder={t('manageUser.searchPlaceholder')}
                  aria-label="Search users"
                />
              </div>
            </div>
            <div className="flex-1">
              <ManageUsersTab searchValue={searchValue} />
            </div>
          </>
        )}
        {selectedMenuIndex === MENU_INDEX.USER_PERMISSION && (
          <>
            <div className="flex flex-row flex-wrap items-center justify-between gap-4 p-6">
              <div className="ml-12">
                <SearchBar
                  className="w-full md:w-60"
                  value={searchValue}
                  setValue={setSearchValue}
                  placeholder={t('manageUser.searchPlaceholder')}
                  aria-label="Search users"
                />
              </div>
            </div>
            <div className="flex-1">
              <UserPermissionTab searchValue={searchValue} />
            </div>
          </>
        )}
        {selectedMenuIndex === MENU_INDEX.MENU_VISIBILITY && (
          <>
            <div className="flex flex-row flex-wrap items-center justify-between gap-4 p-6">
              <div className="ml-12">
                <SearchBar
                  className="w-full md:w-60"
                  value={searchValue}
                  setValue={setSearchValue}
                  placeholder={t('manageUser.searchPlaceholder')}
                  aria-label="Search users"
                />
              </div>
            </div>
            <div className="flex-1">
              <MenuVisibilityTab searchValue={searchValue} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageUser;